import { render } from "./ActivationProcessPage.vue?vue&type=template&id=238869b9"
import script from "./ActivationProcessPage.vue?vue&type=script&lang=js"
export * from "./ActivationProcessPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__